import createHttp from '@/config/http';
import type {
	ConfirmedGraftsResponse,
	IConfirmedPayload,
	IConfirmedTissue,
} from '@/types/confirmedGrafts';
import type { ResponseMetaData } from '@/types/service';

// localhost:3003
const http = createHttp(import.meta.env.VITE_COMMON_URL);

export interface GraftsToAssignPayload {
	page?: number;
	limit?: number;
	columnsFilters?: string;
	search?: string;
	globalFilters?: string;
	sort?: string;
	port?: string;
}

export const getConfirmedGrafts = async ({
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	port = ''
}: GraftsToAssignPayload): Promise<{
	items: IConfirmedTissue[];
	meta: ResponseMetaData;
}> => {
	const response = await http.post<ConfirmedGraftsResponse>(
		'/grafts-to-assign/all-confirmed',
		{
			page: search !== '' ? 1 : page,
			limit,
			products: 'All',
			clinicProductData: '',
			filter: search,
			globalFilters,
			columnsFilters,
			sort,
			port,
		},
	);

	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const updateConfirmedGraft = async (payload: IConfirmedPayload) => {
	const response = await http.post(
		`/grafts-to-assign/confirmed-update`,
		payload,
	);
	return response.data;
};
